import { authQueries } from '@/api/common/auth';
import { useAuthStore } from '@/stores/useAuthStore';
import { useQuery } from '@tanstack/react-query';

export const useWhoAmI = () => {
  // Read signed-in state from the auth store rather than Clerk's `useAuth` directly. The store is
  // populated by `AuthProvider` (real mode) and `MockAuthProvider` (mock mode), so this hook works
  // under both provider trees — in mock mode there is no `<ClerkProvider>`, so calling Clerk's
  // `useAuth` here would throw.
  const isSignedIn = useAuthStore((state) => state.isSignedIn);

  return useQuery({
    ...authQueries.whoAmI(),
    enabled: !!isSignedIn
  });
};
